module.exports = __webpack_public_path__ + "img/about-logos.9c2a943f.png";